import { useState, useCallback } from "react";

const useAlert = () => {
  const [alertState, setAlertState] = useState({
    open: false,
    title: "",
    message: "",
    severity: "info", // 'info', 'warning', 'error', 'success'
    confirmText: "OK",
    showCancel: false,
    cancelText: "Cancel",
    onConfirm: null,
  });

  const showAlert = useCallback(
    ({
      title = "Alert",
      message,
      severity = "info",
      confirmText = "OK",
      showCancel = false,
      cancelText = "Cancel",
      onConfirm = null,
    }) => {
      setAlertState({
        open: true,
        title,
        message,
        severity,
        confirmText,
        showCancel,
        cancelText,
        onConfirm,
      });
    },
    []
  );

  const hideAlert = useCallback(() => {
    setAlertState((prev) => ({ ...prev, open: false }));
  }, []);

  const showInfo = useCallback(
    (message, title = "Information") => {
      showAlert({ title, message, severity: "info" });
    },
    [showAlert]
  );

  const showWarning = useCallback(
    (message, title = "Warning") => {
      showAlert({ title, message, severity: "warning" });
    },
    [showAlert]
  );

  const showError = useCallback(
    (message, title = "Error") => {
      showAlert({ title, message, severity: "error" });
    },
    [showAlert]
  );

  const showSuccess = useCallback(
    (message, title = "Success") => {
      showAlert({ title, message, severity: "success" });
    },
    [showAlert]
  );

  const showConfirm = useCallback(
    ({
      title = "Confirm",
      message,
      confirmText = "Confirm",
      cancelText = "Cancel",
      onConfirm,
    }) => {
      showAlert({
        title,
        message,
        severity: "warning",
        confirmText,
        showCancel: true,
        cancelText,
        onConfirm,
      });
    },
    [showAlert]
  );

  return {
    alertState,
    showAlert,
    hideAlert,
    showInfo,
    showWarning,
    showError,
    showSuccess,
    showConfirm,
  };
};

export default useAlert;
